
import { Component, Vue, Prop } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import i18n from "@/config/i18n";
import {
  addModelNew,
  updModelNew,
  getModelOptionsList,
  deviceModelDetail,
  getManufacturerList,
  addMatching,
  deleteMatching
} from "@/api/api-basic";

@Component
export default class PiNewAdd extends Vue {
  @Prop({
    default: () => {
      return [];
    },
    type: Array
  })
  private devTypeList!: object[];
  private manufacturerNameList: object[] = [
    // {
    //   itemValue: "珠海派诺科技股份有限公司",
    //   itemKey: ""
    // },
    // {
    //   itemValue: "",
    //   itemKey: ""
    // }
  ];

  private tabsActive = "tab1";
  public tabChange(data: string): void {
    this.tabsActive = data;
  }
  private oprList = [];

  private formInline: objAny = {
    type: "",
    deviceType: "",
    alarmLevel: "",
    alarmType: ""
  };

  private modalShow = false;
  private getLoading = false;
  private loading = true;
  private roleList = [];
  private FormData: objAny = {};
  private FormDataAdd: objAny = {};

  private modalTitle = i18n.t("equipmentModel.addDeviceModel");
  private ruleInline: objAny = {
    // deviceType: [
    //   { required: true, message: "请选择设备类型", trigger: "change" }
    // ],
    deviceModelName: [
      {
        required: true,
        message: i18n.t("equipmentModel.deviceModelNamePl"),
        trigger: "blur"
      }
    ],
    manufacturerPkId: [
      {
        required: true,
        message: i18n.t("equipmentModel.manufacturerPkIdPl"),
        trigger: "blur"
      }
    ]
  };

  private ruleInlineAdd: objAny = {
    optionName: [
      {
        required: true,
        trigger: "blur",
        maxlength: 15,
        message: i18n.t("equipmentModel.optionNamePl")
      }
    ],
    optionEnName: [
      {
        required: true,
        trigger: "blur",
        maxlength: 15,
        message: i18n.t("equipmentModel.optionEnNamePl")
      }
    ]
  };
  private deviceTypeList = [];
  private formItem: objAny = {
    deviceModelName: "",
    deviceType: 2,
    manufacturerPkId: "",
    // manufacturerName: "珠海派诺科技股份有限公司",
    matchingOptions: [
      {
        defaultOption: 0,
        deviceType: 2,
        isChecked: 0,
        optionName: "",
        optionPkId: "",
        optionType: 1,
        optionValue: "",
        optionValueDictTypeId: 0,
        optionValueType: 0,
        remark: "",
        sort: 2
      }
    ],
    standardOptions: [
      {
        defaultOption: 0,
        deviceType: 2,
        isChecked: 0,
        optionName: "",
        optionPkId: "",
        optionType: 1,
        optionValue: "",
        optionValueDictTypeId: 0,
        optionValueType: 0,
        remark: "",
        sort: 2
      }
    ]
  };
  // formItemAdd
  private formItemAdd: objAny = {
    optionName: "",
    remark: "",
    optionEnName: "",
    remarkEn: "",

    defaultOption: 0,
    deviceType: 2,
    isChecked: 0,
    optionPkId: "",
    optionType: 2,
    optionValue: "",
    optionValueDictTypeId: 0,
    optionValueType: 0,
    sort: 2
  };
  private tableListFirst: object[] = [];
  private tableColumnsFirst: object[] = [
    {
      title: i18n.t("equipmentModel.isChecked"),
      key: "isChecked",
      resizable: true,
      width: 80,
      slot: "isChecked"
    },
    {
      title: i18n.t("equipmentModel.optionName"),
      key: "optionName",
      resizable: true,
      minWidth: 130
    },
    {
      title: i18n.t("equipmentModel.remark"),
      key: "remark",
      resizable: true
    },
    {
      title: i18n.t("equipmentModel.optionValue"),
      key: "optionValue",
      resizable: true,
      minWidth: 160,
      slot: "optionValue"
    }
  ];

  private tableListSecond: object[] = [];
  private tableColumnsSecond: object[] = [
    {
      title: i18n.t("equipmentModel.isChecked"),
      key: "isChecked",
      resizable: true,
      width: 80,
      slot: "isChecked"
    },
    {
      title: i18n.t("equipmentModel.optionName"),
      key: "optionName",
      resizable: true,
      minWidth: 130
    },
    {
      title: i18n.t("equipmentModel.remark"),
      key: "remark",
      resizable: true
    },
    {
      title: i18n.t("equipmentModel.optionValue"),
      key: "optionValue",
      resizable: true,
      minWidth: 130,
      slot: "optionValueSecond"
    },
    {
      title: i18n.t("operation"),
      key: "action",
      resizable: true,
      width: 60,
      slot: "action"
    }
  ];
  private deviceModelPkId = "";
  private chooseShow = false;
  private loadingAdd = true;
  private isAdd = false;
  private isChange = false;
  private what = "";

  public open(item: objAny, what: string) {
    this.what = what;
    if (!this.FormData.$el) {
      this.$nextTick((): void => {
        this.FormData = this.$refs["formItem"];
        this.FormDataAdd = this.$refs["formItemAdd"];
      });
    } else {
      this.handleReset();
    }

    this.modalShow = true;
    this.getManufacturerNameList();

    if (what === "detail") {
      this.modalTitle = i18n.t("equipmentModel.deviceModelDetails");
      this.isAdd = false;
      this.isChange = false;
      this.deviceModelPkId = item.deviceModelPkId;
      this.deviceModelDetail(item.deviceModelPkId);
    } else if (what === "update") {
      this.modalTitle = i18n.t("equipmentModel.updataDeviceModel");
      this.isChange = true;
      this.isAdd = true;
      this.deviceModelPkId = item.deviceModelPkId;

      this.deviceModelDetail(item.deviceModelPkId);
    } else if (!item) {
      this.formItem.deviceModelName = "";
      this.formItem.deviceType = 2 + "";
      this.formItem.manufacturerPkId = "";
      this.formItem.manufacturerName = "CS Energy";
      this.formItem.matchingOptions = [];
      this.formItem.standardOptions = [];
      this.modalTitle = i18n.t("equipmentModel.addDeviceModel");
      this.isChange = true;
      this.isAdd = true;
      this.getModelOptionsFirst();
      this.getModelOptionsSecond();
    }
  }

  // 选择设备型号获取型号对应标配选配信息
  public handleOptions() {
    if (this.formItem.deviceType) {
      this.getModelOptionsFirst();
      this.getModelOptionsSecond();
    }
  }

  // 选择设备型号获取型号对应标配选配信息
  public handleManufacturerPkId(val: objAny) {
    this.formItem.manufacturerPkId = val;
  }

  public blurInputFirst(row: objAny, index: number) {
    this.$set(this.tableListFirst, index, row);
    if (row.optionPkId === "6" && this.formItem.deviceType === "3") {
      this.tableListFirst.map((item: objAny, i: number) => {
        if (item.optionPkId == 20) {
          item.optionValue = row.optionValue;
          item.disabled = true;
          this.$set(this.tableListFirst, i, item);
        }
      });
    }
  }
  public blurInputSecond(row: objAny, index: number) {
    this.$set(this.tableListSecond, index, row);
  }
  async deleteMatching(row: objAny) {
    const ret = await deleteMatching({ optionPkId: row.optionPkId });
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("deleteSuccess"));
      // this.$emit("success");
      this.getModelOptionsSecond();
    }
  }
  // 厂商下拉接口
  async getManufacturerNameList(): Promise<void> {
    this.manufacturerNameList = [];
    const ret = await getManufacturerList();
    if (ret.status === this.$config.apiStatus) {
      const list: object[] = [];
      ret.data.map((item: objAny) => {
        item.itemKey = item.manufacturerPkId;
        item.itemValue = item.manufacturerName;
        list.push(item);
      });
      this.manufacturerNameList = list;
    }
  }
  async getModelOptionsFirst(): Promise<void> {
    this.tableListFirst = [];
    const param: objAny = {};
    param.optionType = 1;
    param.deviceType = this.formItem.deviceType;
    const ret = await getModelOptionsList(param);
    if (ret.status === this.$config.apiStatus) {
      const list = ret.data;
      list.map((item: objAny) => {
        item.isChecked = 1;
        item.isTrue = true;
      });
      this.tableListFirst = list;
    }
  }
  async getModelOptionsSecond(): Promise<void> {
    this.tableListSecond = [];
    const param: objAny = {};
    param.optionType = 2;
    param.deviceType = this.formItem.deviceType;
    const ret = await getModelOptionsList(param);
    if (ret.status === this.$config.apiStatus) {
      const list = ret.data;
      list.map((item: objAny) => {
        if (item.isChecked === 0) {
          item.isTrue = false;
        } else {
          item.isTrue = true;
        }
      });
      this.tableListSecond = list;
    }
  }
  async deviceModelDetail(val: string): Promise<void> {
    const ret = await deviceModelDetail({ deviceModelPkId: val });
    if (ret.status === this.$config.apiStatus) {
      this.formItem.deviceModelName = ret.data[0].deviceModelName;
      this.formItem.deviceType = ret.data[0].deviceType + "";
      this.formItem.deviceModelPkId = ret.data[0].deviceModelPkId;
      this.formItem.manufacturerPkId = ret.data[0].manufacturerPkId;
      this.formItem.manufacturerName = ret.data[0].manufacturerName;

      ret.data[0].standardOptions.map((item: objAny) => {
        if (item.isChecked === 0) {
          item.isTrue = false;
        } else {
          item.isTrue = true;
        }
      });

      ret.data[0].matchingOptions.map((item: objAny) => {
        if (item.isChecked === 0) {
          item.isTrue = false;
        } else {
          item.isTrue = true;
        }
      });
      this.tableListSecond = ret.data[0].matchingOptions;
      this.tableListFirst = ret.data[0].standardOptions;
    }
    this.$forceUpdate();
  }

  public isBoxCheckedFirst(row: objAny, index: number): void {
    if (row.isTrue) {
      row.isChecked = 1;
    } else {
      row.isChecked = 0;
    }
    this.$set(this.tableListFirst, index, row);
  }

  public isBoxCheckedSecond(row: objAny, index: number): void {
    if (row.isTrue) {
      row.isChecked = 1;
    } else {
      row.isChecked = 0;
    }
    this.$set(this.tableListSecond, index, row);
  }

  public addFormData(): void {
    this.chooseShow = true;
    this.FormDataAdd.resetFields();
    // this.formItemAdd.optionName = "";
    // this.formItemAdd.remark = "";
  }

  public handleSubmit(): void {
    let flag = true;
    this.tableListFirst.map((item: objAny) => {
      if (item.isChecked === 1) {
        if (!item.optionValue) {
          flag = false;
        }
      }
    });
    if (flag) {
      this.loading = true;
      this.FormData.validate((valid: boolean) => {
        if (valid) {
          this.submitData();
        } else {
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      });
    } else {
      this.$Message.error(i18n.t("equipmentModel.optionValueError"));
      // this.modalShow = true;
      this.loading = false;
      this.$nextTick(() => {
        this.loading = true;
      });
    }
  }
  public closeModal(): void {
    this.modalShow = false;
  }
  public closeChooseShow(): void {
    this.chooseShow = false;
  }
  public handleReset(): void {
    this.FormData.resetFields();
  }
  public submitChooseShow(): void {
    this.formItemAdd.deviceType = this.formItem.deviceType;

    this.formItemAdd.defaultOption = 0;
    this.formItemAdd.deviceType = 2;
    this.formItemAdd.isChecked = 0;
    this.formItemAdd.optionPkId = "";
    this.formItemAdd.optionType = 2;
    this.formItemAdd.optionValue = "";
    this.formItemAdd.optionValueDictTypeId = 0;
    this.formItemAdd.optionValueType = 1;

    const preSort: objAny = this.tableListSecond[
      this.tableListSecond.length - 1
    ];
    this.formItemAdd.sort = preSort.sort + 1;

    this.FormDataAdd.validate((valid: boolean) => {
      if (valid) {
        if (this.formItemAdd.optionName) {
          // const json = JSON.parse(JSON.stringify(this.formItemAdd));
          // this.tableListSecond.push(json);
          // this.chooseShow = false;
          this.addMatching();
        }
      } else {
        this.loadingAdd = false;
        this.$nextTick(() => {
          this.loadingAdd = true;
        });
      }
    });
  }
  async addMatching() {
    // this.formItemAdd.defaultOption = 0;
    // this.formItemAdd.deviceType = 2;
    // this.formItemAdd.isChecked = 0;
    // this.formItemAdd.optionPkId = "";
    // this.formItemAdd.optionType = 2;
    // this.formItemAdd.optionValue = "";
    // this.formItemAdd.optionValueDictTypeId = 0;
    // this.formItemAdd.optionValueType = 1;
    const param = {
      deviceType: 2,
      optionName: this.formItemAdd.optionName,
      optionEnName: this.formItemAdd.optionEnName,
      remarkEn: this.formItemAdd.remarkEn,
      optionType: 2,
      optionValueType: 1,
      remark: this.formItemAdd.remark,
      unit: ""
    };
    const ret = await addMatching(param);
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("addSuccess"));
      this.$emit("success");
      this.getModelOptionsSecond();

      this.chooseShow = false;
    }
  }

  async submitData(): Promise<void> {
    this.formItem.standardOptions = this.tableListFirst;
    this.formItem.matchingOptions = this.tableListSecond;
    let ret: objAny;

    if (!this.what) {
      ret = await addModelNew(this.formItem);
      if (ret.status === this.$config.apiStatus) {
        this.$Message.success(i18n.t("addSuccess"));
        this.$emit("success");
        this.modalShow = false;
        // this.loading = false;
      }
    }

    if (this.what === "update") {
      ret = await updModelNew(this.formItem);
      if (ret.status === this.$config.apiStatus) {
        this.$Message.success(i18n.t("updateSuccess"));
        this.$emit("success");
        this.modalShow = false;
        // this.loading = false;
      }
    }

    if (this.what === "detail") {
      this.modalShow = false;
    }

    this.loading = false;
  }
  mounted() {
    this.$emit("getChild", this);
  }
}
